/* eslint-disable import/prefer-default-export */
import axios from '../axios';

// ---------------------------------------------------------------------------
// RH — Catálogo relacional de tipos de documento (handoff 0065 §7).
//
// Substitui o ENUM fixo de tipos: `scope=EMPLOYEE` popula o dropdown de
// documentos do funcionário; `scope=HR_ADMISSION` lista os tipos do checklist
// de admissão (usado no select de requisitos por cargo). Item:
// { id, code, name, collection_kind }. Escrita (POST/PUT) existe no backend
// (hr:document_type:manage) mas não tem UI ainda — catálogo gerido por seed.
// ---------------------------------------------------------------------------

export async function listDocumentTypes({ scope } = {}) {
   const params = {};
   if (scope) params.scope = scope;

   const response = await axios.get('/hr/document-types', { params });

   // Leitura defensiva do envelope (padrão hrApi.getDepartments).
   return (
      response?.data?.data?.document_types ??
      response?.data?.data?.documentTypes ??
      []
   );
}
